import { render, staticRenderFns } from "./SalesOrderDetailList.vue?vue&type=template&id=981beaf0&"
import script from "./SalesOrderDetailList.vue?vue&type=script&lang=js&"
export * from "./SalesOrderDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports